"use client"

import { useState, useEffect, useRef } from "react"
import Draft from "./Draft"
import Outline from "./Outline"
import Slide from "./Slide"
import FinalReport from "./FinalReport"
import { Sparkles } from "lucide-react"

export default function OutputTabs( {activeTabName, outline, setOutline, draftContents, draftFigs, updateDraftFigs, reportContents, reportFigs, updateReportFigs, showOutlineProcessing, showDraftProcessing, showReportProcessing, showSlideProcessing, replaceDraftGraphFlg, replaceReportGraphFlg, slideContents, replaceSlideGraphFlg} ) {
  const [activeTab, setActiveTab] = useState(activeTabName)
    
  const tabs = ["アウトライン", "ドラフト", "レポート", "スライド"]

  useEffect(() => {
    setActiveTab(activeTabName)
  }, [activeTabName])
  
  const showLabel = (tab) => {
    if (tab == "アウトライン") {
      return true;
    } else if (tab == "ドラフト") {
      if (draftContents || showDraftProcessing) {
        return true
      } else {
        return false
      }
    } else if (tab == "レポート") {
      if (reportContents || showReportProcessing) {
        return true
      } else {
        return false
      }
    } else if (tab == "スライド" || showSlideProcessing) {
      if (slideContents) {
        return true
      } else {
        return false
      }
    }
  }

  const isPorocessing = (tab) => {
    if (tab == "アウトライン") {
      if (showOutlineProcessing) {
        return true;
      }
    } else if (tab == "ドラフト") {
      if (showDraftProcessing) {
        return true;
      }
    } else if (tab == "レポート") {
      if (showReportProcessing) {
        return true;
      }
    } else if (tab == "スライド") {
      if (showSlideProcessing) {
        return true;
      }
    } 
    return false;
  }

  const SparklesIcon = () => {
    return (
      <>
        <Sparkles className="h-[15px] w-[15px] text-[#66cdaa] animate-blink" />
        <style jsx global>{`
          @keyframes blink {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.3; }
          }
          .animate-blink {
            animation: blink 1.5s ease-in-out infinite;
          }
        `}</style>
      </>
    )
  }
  

  const editOutline = (updatedMarkdown) => {
    setOutline(updatedMarkdown)
  }

  return (
    <div className="w-full mt-0 bg-white p-6 rounded-xl h-[calc(100%-100px)] shadow-xl flex-1">
      <div className="flex border-b border-gray-200">
        {tabs.map((tab) => (
          <button
            key={tab}
            className={`py-2 px-4 text-sm font-medium ${
               activeTab === tab ? "text-green-600 border-b-2 border-green-600" : "text-gray-500 hover:text-gray-700"
              } ${showLabel(tab) ? "" : "hidden"}`
            
            }
            onClick={() => setActiveTab(tab)}
          >
          <div className="flex">
            <div className="flex justify-center items-center">{tab}</div>
            {isPorocessing(tab) &&
              <div className="flex justify-center items-center ml-2"><SparklesIcon /></div>
            }
          </div>
          </button>
        ))}
      </div>
      <div className="mt-4 bg-white w-full h-[calc(100%-100px)]">
        {activeTab === "アウトライン" && (
          <Outline outline={outline} setOutline={setOutline} showOutlineProcessing={showOutlineProcessing} onEdit={editOutline} />
        )}
        {activeTab === "ドラフト" && draftContents && (
          <Draft contents={draftContents} draftFigs={draftFigs} updateDraftFigs={updateDraftFigs} showDraftProcessing={showDraftProcessing} replaceGraphFlg={replaceDraftGraphFlg} />
        )}
        {activeTab === "レポート" && (
          <FinalReport contents={reportContents} reportFigs={reportFigs} updateReportFigs={updateReportFigs} showReportProcessing={showReportProcessing} replaceGraphFlg={replaceReportGraphFlg} />
        )}
        {activeTab === "スライド" && (
          <Slide contents={slideContents} showSlideProcessing={showSlideProcessing} replaceGraphFlg={replaceSlideGraphFlg} />
        )}
      </div>
    </div>
  )
}

